var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectCarouselLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 123,
    viewBox: "0 0 400 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9789 56.588 18.979 56.5879C34.6036 47.1115 55.7332 49.2135 74.2849 53.5885 77.372 54.3165 80.4741 55.0985 83.5889 55.8838 99.1334 59.8025 114.996 63.8013 130.899 61.5687L130.83 61.0735 130.899 61.5687C151.004 58.7433 166.482 46.8966 181.689 34.5251 182.65 33.7433 183.61 32.9594 184.57 32.1755 198.833 20.5277 213.098 8.87795 231.052 3.95218 252.601-1.95664 276.19 2.906 297.022 10.8105 305.787 14.1363 314.288 17.9865 322.801 21.8425 324.406 22.5692 326.011 23.2962 327.618 24.0199 337.746 28.5801 347.959 33.007 358.679 36.4046 372.172 40.681 386.384 43.1577 400.684 43.8805 426.134 45.176 451.967 40.9813 475.156 31.6457 478.325 30.3706 481.761 28.3016 485.251 26.2007 486.261 25.5924 487.276 24.9815 488.29 24.3863 492.847 21.712 497.398 19.3486 501.638 18.7661v0C506.864 18.0455 511.31 20.6136 514.678 24.411 518.049 28.2115 520.275 33.1807 521.039 37.0702L521.53 36.9739 521.039 37.0705C523.208 48.0867 518.326 59.5191 510.551 68.5341 502.774 77.5521 492.364 84.5121 481.994 91.3654 435.224 122.277 387.599 152.733 334.797 174.791L334.99 175.252 334.797 174.791C281.998 196.857 223.26 210.262 165.133 205.199 106.999 200.137 49.7388 174.912 17.378 132.262L16.9797 132.564 17.378 132.262C8.47312 120.526 1.4399 107.297.578705 93.3074L.0796794 93.3382.578704 93.3074C-.2817 79.3392 5.91168 64.5104 18.9789 56.588z",
    fill: "url(#paint0_linear)",
    stroke: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 628.556,
    y1: 102.976,
    x2: -129.47,
    y2: 102.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 628.556,
    y1: 102.976,
    x2: -129.47,
    y2: 102.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectCarouselLogin);
export default __webpack_public_path__ + "static/media/vect-carousel-login.bb1c0a43970ab57118e51efefa345917.svg";
export { ForwardRef as ReactComponent };